function isMissing(value) {
    if (value instanceof Array) {
        return value.length === 0;
    } else if (typeof value === "string") {
        return !value;
    } else if (typeof value === "number") {
        return isNaN(value);
    } else {
        return value == null;
    }
}

export default isMissing;



// WEBPACK FOOTER //
// ./app/data/util/isMissing.js